// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__iXR5Q","inner":"Footer_inner__2gIo7","nextIcon":"Footer_nextIcon__3B3Z_","innerLeft":"Footer_innerLeft__1fq6m"};